import { ReactElement } from 'react';
import flow from 'lodash/fp/flow';
import { formatDistance } from 'date-fns/fp';

import { translate } from '@micro-apps/env';

const getLastUpdatedLabel = flow(
	formatDistance(new Date()),
	updatedTime => `${translate('Updated')} ${updatedTime} ${translate('ago')}`
);

type Props = {
	lastUpdated?: Date;
};

export default function CalendarMeta({ lastUpdated }: Props): ReactElement {
	return (
		<div className="Calendar-Meta-inner">
			<ul className="legend-list">
				<li className="legend-item ty-c4">
					<span className="legend-icon legend-icon--restricted" />
					<p>{translate('Restricted')}</p>
				</li>
				<li className="legend-item ty-c4">
					<span className="legend-icon legend-icon--unavailable" />
					<p>{translate('Unavailable')}</p>
				</li>
			</ul>

			{lastUpdated && (
				<div className="Calendar-updated">
					<p>{getLastUpdatedLabel(lastUpdated)}</p>
				</div>
			)}
		</div>
	);
}
